import { render, staticRenderFns } from "./degree.vue?vue&type=template&id=6fc2365f"
import script from "./degree.vue?vue&type=script&lang=js"
export * from "./degree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports